"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PoliciesDeterminedByAccommodations() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section id="1-οι-πολιτικές-καθορίζονται-από-τα-καταλύματα" className="bg-background py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="lg:col-span-8 flex flex-col gap-8">
            <div className="flex gap-5 md:gap-6 items-stretch">
              {}
              <div className="w-1 bg-accent shrink-0 rounded-sm" aria-hidden="true" />
              <h1 className="font-default font-bold text-primary text-[clamp(2.5rem,4vw,5rem)] leading-[1.1] tracking-tight">
                Οι Πολιτικές Καθορίζονται από τα Καταλύματα
              </h1>
            </div>
            
            <div className="md:ml-7 lg:ml-8">
              <p className="font-sans text-foreground/90 text-lg md:text-xl leading-[1.6] max-w-prose">
                Οι όροι ακύρωσης, τροποποίησης ημερομηνιών, καθώς και οι χρεώσεις
                για μη εμφάνιση (no-show), καθορίζονται αποκλειστικά και αυστηρά
                από το εκάστοτε κατάλυμα (ξενοδοχείο, βίλα, ενοικιαζόμενο δωμάτιο)
                και όχι από την πλατφόρμα μας. Κάθε δωμάτιο ή προσφορά μπορεί να
                υπόκειται σε διαφορετικούς όρους (π.χ. "Δωρεάν Ακύρωση", "Μη
                Επιστρέψιμη Τιμή").
              </p>
            </div>
          </div>

          {}
          <div className="lg:col-span-4 hidden lg:block" aria-hidden="true">
            {}
          </div>
        </div>
      </div>
    </section>;
}